import { styled } from '@mui/material/styles';
import { AccordionSummary, IconButton, Typography, Accordion, Divider, AccordionDetails } from '@mui/material';

export const StyledAccordion = styled(Accordion)({
  width: 'calc(100% - 36px)',
  '&:before': {
    display: 'none'
  }
});

export const SectionDivider = styled(Divider)({
  width: 'calc(100% - 26px)'
});

export const StyledAccordionSummary = styled(AccordionSummary)({
  height: '68px'
});

export const StyledAccordionDetails = styled(AccordionDetails)({
  marginTop: '-10px'
})

export const ListDataValue = styled(Typography)({
  fontSize: '14px',
  fontFamily: 'Open Sans',
  fontWeight: 400,
  paddingTop: 0,
  height: '18px',
  lineHeight: '17px',
  marginBottom: '10px',
  letterSpacing: 0.15,
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical'
});

export const TypographyStyled = styled(Typography)({
  fontSize: '14px',
  fontFamily: 'Open Sans',
  fontWeight: 400
});

export const RemoveItemContainer = styled('div')({
  height: '18px'
});

export const RemoveItemIcon = styled('div')({
  marginLeft: '8px',
  marginRight: '10px',
  textTransform: 'none',
  '&:hover': {
    color: 'transparent',
    backgroundColor: 'transparent'
  }
});

export const RemoveItemButton = styled(IconButton)({
  marginTop: '-48px',
  marginBottom: '0px',
  textTransform: 'none',
  '&:hover': {
    color: 'transparent',
    backgroundColor: 'transparent'
  }
});
